export default {
  'menu.workbench': 'workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.template': 'Template',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.luole-admin.dashboard': 'Dashboard',
  'menu.luole-admin.architect-talent-ops': 'Talent Portal',
  'menu.luole-admin.architect-talent-ops.overview': 'Operations Overview',
  'menu.luole-admin.architect-talent-ops.applications': 'Application Details',
  'menu.luole-admin.architect-talent-ops.luole-admin.architect-talent-ops.overview':
    'Operations Overview',
  'menu.luole-admin.architect-talent-ops.luole-admin.architect-talent-ops.applications':
    'Application Details',
  'menu.luole-admin.architect-talent-ops.luole-admin.member.management':
    'Talent Pool',
  'menu.luole-admin.architect-talent-ops.luole-admin.inviteManagement':
    'Invite Management',
  'menu.luole-admin.architect-talent-ops.luole-admin.schoolShowcase':
    'Campus Showcase',
  'menu.luole-admin.architect-talent-ops.luole-admin.carousel.management':
    'Carousel',
  'menu.luole-admin.architect-talent-ops.luole-admin.contentMarketing.management':
    'Content Marketing',
  'menu.luole-admin.recruitment-assistant-ops': 'Enterprise Portal',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.recruitment-assistant-ops.overview':
    'Operations Overview',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.recruitment-assistant-ops.ai-job-monitor':
    'AI Job Matching',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.recruitment-assistant-ops.enterprise-portrait':
    'Enterprise Portrait',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.recruitment-assistant-ops.enterprise-portrait.detail':
    'Enterprise Portrait Detail',
  'menu.luole-admin.campus-ops': 'Campus Ops',
  'menu.luole-admin.institution.verify': 'Institution Verification',
  'menu.luole-admin.campus-ops.luole-admin.institution.verify':
    'Institution Verification',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.campus-ops':
    'Campus Ops',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.enterprise.list':
    'Enterprise Library',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.enterprise.users':
    'Enterprise Users',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.enterprise.verify':
    'Enterprise Verification',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.institution.verify':
    'Institution Verification',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.campus-ops.luole-admin.institution.verify':
    'Institution Verification',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.demoReservation':
    'Demo Reservations',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.userFeedback':
    'User Feedback',
  'menu.luole-admin.recruitment-assistant-ops.luole-admin.registrationChannels':
    'Channel Management',
  'menu.luole-admin.recruitment': 'Recruitment',
  'menu.luole-admin.activity': 'Activities',
  'menu.luole-admin.system': 'System Settings',
  'menu.luole-admin.system.role-permissions': 'Roles & Permissions',
  'menu.luole-admin.system.members': 'Members',
  'menu.luole-admin.content': 'Content',
  'menu.luole-admin.feedback': 'Feedback',
  'menu.luole-admin.analytics.recruitment': 'Recruitment Ops',
  'menu.luole-admin.job': 'Jobs',
  'menu.luole-admin.job.management': 'Job Management',
  'menu.luole-admin.member': 'Talent',
  'menu.luole-admin.member.management': 'Talent Pool',
  'menu.luole-admin.inviteManagement': 'Invite Management',
  'menu.luole-admin.talent.create': 'Create Talent',
  'menu.luole-admin.enterprise': 'Enterprise Management',
  'menu.luole-admin.enterprise.list': 'Enterprise Library',
  'menu.luole-admin.enterprise.users': 'Enterprise Users',
  'menu.luole-admin.enterprise.verify': 'Enterprise Verification',
  'menu.luole-admin.enterprise.create': 'Create Enterprise',
  'menu.luole-admin.enterprise.edit': 'Edit Enterprise',
  'menu.luole-admin.resume.templates': 'Resume Templates',
  'menu.luole-admin.application': 'Applications',
  'menu.luole-admin.talent.recommendation': 'Talent Recommendation',
  'menu.luole-admin.job-fair': 'Job Fairs',
  'menu.luole-admin.job-fair.management': 'Job Fair Management',
  'menu.luole-admin.job-fair.detail': 'Job Fair Detail',
  'menu.luole-admin.job-fair.create': 'Create Job Fair',
  'menu.luole-admin.job-fair.edit': 'Edit Job Fair',
  'menu.luole-admin.job-fair.info.add': 'Add Info',
  'menu.luole-admin.job-fair.info.edit': 'Edit Info',
  'menu.luole-admin.schoolShowcase': 'School Showcase',
  'menu.luole-admin.schoolShowcase.create': 'Create School Showcase',
  'menu.luole-admin.schoolShowcase.edit': 'Edit School Showcase',
  'menu.luole-admin.global': 'Global',
  'menu.luole-admin.global.dictionary': 'Job Categories',
  'menu.luole-admin.carousel': 'Carousel',
  'menu.luole-admin.carousel.management': 'Carousel Management',
  'menu.luole-admin.carousel.create': 'Create Carousel',
  'menu.luole-admin.carousel.edit': 'Edit Carousel',
  'menu.luole-admin.contentMarketing.management': 'Content Marketing',
  'menu.luole-admin.contentMarketing.create': 'Create Content',
  'menu.luole-admin.contentMarketing.edit': 'Edit Content',
  'menu.luole-admin.task.management': 'Task Management',
  'menu.luole-admin.forumRegistration': 'Forum Registration',
  'menu.luole-admin.forumRegistration.detail': 'Forum Registration Detail',
  'menu.luole-admin.jobFairRegistration': 'Job Fair Registration',
  'menu.luole-admin.jobFairRegistration.detail': 'Job Fair Registration Detail',
  'menu.luole-admin.demoReservation': 'Demo Reservations',
  'menu.luole-admin.userFeedback': 'User Feedback',
  'menu.luole-admin.registrationChannels': 'Channel Management',
  'menu.luole-admin.userFeedback.detail': 'Feedback Detail',
};
